<template>
   <div class="centerx" id="view-invoice">
    <vs-popup class="view-invoice" title="View Invoice" :active.sync="popupViewInvoice.isOpen" fullscreen>
      <div class="popup-view-invoice-content">
        <div class="lg:flex h-full">
           <div class="lg:w-2/3 w-full flex flex-col align-center position-relative left-content row d-flex justify-content-end w-100" id="print-invoice">
            <vx-card class="w-11/12 m-base p-6 view-invoice-card offset-3 col-6" id="download-invoice" ref="document">
              <div>
                <div class="text-center my-base">
                  <h3 class="font-bold">Invoice</h3>
                  <p class="pt-2 text-grey-custom my-text-color">{{changeFormatDate(checkoutData.create_at)}}</p>
                </div>
                <div class="invoice-items border-top border-top-custom my-padding" v-for="(item,index) in staffService" :key="index">
                  <div class="d-flex justify-content-between align-items-center flex justify-between align-center">
                    <div>
                      <!-- <p class="p-0 text-grey-custom" style="color: #9198a0">1 item</p> -->
                      <div class="p-0 text-lg font-bold font-weight-bold mr-3 service-name">{{item.service.name}}</div>
                      <div class="p-0 text-grey-custom my-text-color" v-if="item.staff">with {{item.staff.name}}</div>
                    </div>
                    <div class="text-lg font-bold font-weight-bold" v-if="item.service_price">
                      ${{item.service_price}}
                    </div>
                    <div class="text-lg font-bold font-weight-bold" v-else>$0</div>
                  </div>
                </div>

                <div class="invoice-items border-top border-top-custom my-padding">
                  <div class="d-flex justify-content-between align-items-center flex justify-between align-center text-lg font-bold font-weight-bold">
                    <div>Subtotal</div>
                    <div>${{this.subtotal.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</div>
                  </div>
                </div>

                <div class="invoice-items border-top border-top-custom my-padding">
                  <div class="font-bold font-weight-bold text-lg">Discount</div>
                  <div>
                    <div v-if="this.promotionAdded.checked == true" class="my-text-color">
                        <div class="d-flex justify-content-between align-items-center flex justify-between align-center w-full p-0 pr-1 pl-3">
                            <div class="popup-new-ver-ellipsis p-0">{{promotionAdded.campaign.name}}</div>
                            <div v-if="promotionAdded.campaign.logic_type=='usd'">- ${{promotionAdded.campaign.logic_value}}</div>
                             <div v-else>- {{promotionAdded.campaign.logic_value}}%</div>
                        </div>
                    </div>
                    <div v-for="(redem) in redemtionAdded" :key="redem.id" class="my-text-color">
                      <div class="d-flex justify-content-between align-items-center flex justify-between align-center w-full p-0 pr-1 pl-3" v-if="redem.checked == true">
                        <div class="popup-new-ver-ellipsis p-0">{{redem.content}}</div>
                        <div v-if="redem.logic_type=='usd'">- ${{redem.logic_value}}</div>
                        <div v-else>- {{redem.logic_value}}%</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="invoice-items border-top border-top-custom my-padding">
                  <div class="d-flex justify-content-between align-items-center flex justify-between align-center text-lg font-bold font-weight-bold">
                    <div>Total</div>
                    <div>${{(total_price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</div>
                  </div>
                </div>

                <div class="invoice-items border-top border-top-custom my-padding">
                  <div class="d-flex justify-content-between align-items-center flex justify-between align-center">
                    <div>
                      <div class="p-0 text-lg font-bold font-weight-bold">Payment Card/Cash</div>
                      <div class="p-0 text-grey-custom my-text-color">{{changeFormatDateTime(checkoutData.create_at)}}</div>
                    </div>
                    <div class="text-lg font-bold font-weight-bold">${{(total_price).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}}</div>
                  </div>
                </div>

                <div class="invoice-items border-top border-top-custom my-padding">
                  <div class="d-flex justify-content-between align-items-center flex justify-between align-center text-lg font-bold font-weight-bold">
                    <div>Balance</div>
                    <div>$0</div>
                  </div>
                </div>
              </div>
            </vx-card>
           </div>
           <div class="lg:w-1/3 lg:pt-0 pt-5 w-full h-full position-relative border-left-custom">
             <div>
                <div class="w-full" v-if="popupViewInvoice.item_info.customer">
                  <div class="flex justify-between align-center pb-4">
                      <div class="flex align-center">
                        <div v-if="popupViewInvoice.item_info.customer.image_url">
                           <vs-avatar :src="popupViewInvoice.item_info.customer.image_url" size="60px" class="mx-5 text-4xl" />
                        </div>
                        <div v-else>
                          <vs-avatar :text="StringHelper.changeFormatAvatar(popupViewInvoice.item_info.customer.full_name)" size="60px" class="mx-5 text-4xl" />
                        </div>
                          <div>
                              <div class="flex font-bold text-lg justify-between">
                                  <div class="mr-3 customer-name">{{popupViewInvoice.item_info.customer.full_name}}</div>
                                  <vs-alert color="success" class="flex align-center justify-center text-sm customer-type">New</vs-alert>
                              </div>
                              <div class="flex text-grey-custom text-sm mt-2">
                                  <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 mr-1" />
                                  <span>{{StringHelper.phoneNumberFormat(popupViewInvoice.item_info.customer.phone, true)}}</span>
                              </div>
                          </div>
                      </div>
                      <!-- <feather-icon icon="ChevronRightIcon" svgClasses="h-5 w-5 stroke-current cursor-pointer" @click="changeStatus" v-show="!showInfo"/>
                      <feather-icon icon="ChevronLeftIcon" svgClasses="h-5 w-5 stroke-current cursor-pointer" @click="changeStatus" v-show="showInfo"/> -->
                  </div>
                </div>
              </div>

              <div class="w-full toggle-content">
                <div class="w-full h-full overflow-hidden">
                  <div class="mb-4" v-if="popupViewInvoice.item_info.customer">
                      <div class="vx-row mx-5">
                          <div class="vx-col w-6/24 mb-2 p-0">
                              <div class="text-sm text-grey-custom">Points</div>
                              <p class="text-sm p-0 pt-1">{{popupViewInvoice.item_info.customer.current_point}} Pts</p>
                          </div>
                          <div class="vx-col w-6/24 mb-2 p-0">
                              <div class="text-sm text-grey-custom">Visit</div>
                              <div v-if="customerInfo">
                                <p class="text-sm p-0 pt-1" v-if="customerInfo > 1">{{customerInfo.visit_count}} times</p>
                                <p class="text-sm p-0 pt-1" v-else>{{customerInfo.visit_count}} time</p>
                              </div>
                              <div v-else>
                                <p class="text-sm p-0 pt-1">0 time</p>
                              </div>
                          </div>
                          <div class="vx-col w-12/24 mb-2 p-0">
                              <div class="text-sm text-grey-custom">Check in</div>
                              <p class="text-sm p-0 pt-1">{{changeFormat(popupViewInvoice.item_info.customer.create_at)}}</p>
                          </div>
                      </div>
                      <div class="flex ml-5 mr-1 align-center cursor-pointer" @click="popupNote = true">
                          <div class="flex align-center text-sm break-word p-0 text-grey-custom" style="height: 35px">
                              <span class="font-semibold">Note:</span>
                              <div class="text-grey-custom ml-2 break-word popup-new-ver-note note-content" v-if="checkout_info">{{note_view}}</div>
                          </div>
                          <div class="ml-auto">
                              <i class="material-icons ml-auto cursor-pointer bg-primary gradient gradient-primary no-shadow text-white user-select-none popup-new-ver-edit-icon">create</i>
                          </div>
                      </div>

                      <vs-popup class="checkout-popup-note" title="Note" :active.sync="popupNote">
                          <div class="pt-4">
                              <vs-textarea :maxlength="1024" v-model="note" height="200"/>
                              <btn-custom @click="updateNote">Save</btn-custom>
                          </div>
                      </vs-popup>
                  </div>
                  <vs-divider class="mb-0"></vs-divider>
                  <div class="w-full pl-5 overflow-auto" style="height: calc(100% - 205px)">
                    <div class="flex flex-col justify-between h-full">
                      <div>
                        <div class="flex flex-col align-center mt-4">
                          <img src="../../assets/images/checkout.svg" class="checkout-img" />
                        </div>
                        <h3 class="text-center font-bold" style="margin-top:10px;">Completed</h3>
                        <p class="text-center text-grey-custom">Full payment received on {{changeFormatDate(checkoutData.create_at)}}</p>
                      </div>

                      <!-- <div class="centerx mt-auto mb-4 pt-6">
                        <label>Send Invoice</label>
                        <div class="flex">
                            <vs-input color="dark" class="w-3/4 m-0 email-view-invoice-input" icon-pack="feather" icon="icon-mail" placeholder="Email Address" v-model="email_temp" icon-no-border v-on:keypress="StringHelper.validateEmailChar($event, email_temp)"/>
                            <vs-button color="dark" type="filled" class="w-1/4 rounded-item rounded-item-right text-sm" disabled v-if="!StringHelper.validateEmail(email_temp)">SEND</vs-button>
                            <vs-button color="dark" type="filled" class="w-1/4 rounded-item rounded-item-right text-sm" v-else @click="sendInvoice">SEND</vs-button>
                        </div>
                      </div> -->
                  </div>


                    <div class="flex flex-col align-center pt-4 pb-1 border-top-custom w-full pl-5 con-btn-checkout mt-5">
                      <vs-row vs-w="12">
                        <vs-col vs-w="6" class="pr-2">
                          <!-- <vs-button color="#a4adba" type="filled" class="w-full">More Option</vs-button> -->
                          <vs-dropdown vs-trigger-click class="cursor-pointer vx-col w-custom ml-auto w-full">
                            <div class="px-3 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-center font-medium shadow-md" style="height: 38px">
                              <span class="font-bold text-sm xl:px-5 px-0">MORE OPTIONS</span>
                              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu class="dropdown-appointment">
                              <vs-dropdown-item @click="download">
                                <span>Download</span>
                              </vs-dropdown-item>
                              <vs-dropdown-item @click="print">
                                <span>Print</span>
                              </vs-dropdown-item>
                            </vs-dropdown-menu>
                          </vs-dropdown>
                        </vs-col>
                        <vs-col vs-w="6" class="pl-2">
                          <vs-button color="primary" type="filled" class="gradient gradient-primary no-shadow w-full text-sm" @click="popupViewInvoice.isOpen=false">CLOSE</vs-button>
                        </vs-col>
                      </vs-row>
                    </div>
                  </div>
                </div>
              </div>
           </div>
        </div>
      </div>
    </vs-popup>
   </div>
</template>
<script>
import { StringHelper } from '../../models/string_helper'
import {changeFormatWithDateTime} from '../../helper/datetimeHelper';
import moment from 'moment';
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';
import html2pdf from 'html2pdf.js'


const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    '../../assets/css/viewInvoice.css',
    '../../assets/css/general.css',
  ]
}

Vue.use(VueHtmlToPaper, options);

export default {
  name : 'vs-view-invoice',
  props:{
    promotionAdded: {
      type: Object,
    },
    redemtionAdded: {
      type: Array,
    },
    popupViewInvoice :{
      type: Object,
      required: true,
    },
    staffService :{
      type: Array,
      required: true,
    },
    total_price: {
      type: Number,
      required: true,
    },
    subtotal: {
      type: Number,
      required: true,
    },
    customerInfo: {
      type: Object,
      required: true
    }
  },
  components:{
    moment
  },
  data(){
    let note_temp = '';
    if(this.popupViewInvoice.item_info.check_out) {
        // note_temp = this.popupViewInvoice.item_info.check_out.note;
      this.$store.dispatch("checkin/GET_CHECKOUT_INFO", {id: this.popupViewInvoice.item_info.check_out.id}).then(() => {
        if(this.checkout_info.customer) {
            note_temp = this.checkout_info.customer.note;
        }
      })
    }
    let email_temp = '';
    if(this.popupViewInvoice.item_info && this.popupViewInvoice.item_info.customer){
      email_temp = this.popupViewInvoice.item_info.customer.email;
    }
    return{
      output: null,
      StringHelper,
      note_temp,
      popupNote: false,
      email_temp,
      note_view: ''
    }
  },
  watch:{
    popupViewInvoice: {
      immediate: true,
      deep: true,
      handler() {
        if(this.popupViewInvoice.isOpen) {
          document.body.classList.add('overflow-hidden');
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }
    },
    popupNote: {
      immediate: true,
      deep: true,
      handler() {
        // if(this.checkout_info && this.checkout_info.customer) {
        //     this.note_temp = this.checkout_info.customer.note;
        // }
        if(this.popupNote) {
          this.note_temp = this.note_view;
        }
      }
    },
    checkout_info: {
      immediate: true,
      deep: true,
      handler() {
        if(this.checkout_info && this.checkout_info.customer) {
          this.note_temp = this.checkout_info.customer.note;
          this.note_view = this.note_temp;
        }
      }
    }
  },
  methods:{
    download(){
      var element = document.getElementById('download-invoice');
        html2pdf(element, {
          margin: 1,
					filename: 'GCI2020.pdf',
					image: { type: 'jpeg', quality: 0.98 },
					html2canvas: { dpi: 100, letterRendering: true },
					jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' }
				})
    },
    print(){
      this.$htmlToPaper('print-invoice');
    },
    getTotal() {
      let total = 0;
        for (let i = 0; i < this.staffService.length; i++) {
          if (!isNaN(parseFloat(this.staffService[i].service_price))) {
            total = parseFloat(total) + parseFloat(this.staffService[i].service_price);
          }
        }
      return total
    },
    changeFormat(day){
      if(day) {
        return changeFormatWithDateTime(day);
      } else {
        return 'N/A';
      }
    },
    changeFormatDateTime(day){
      if(day) {
        return moment(day).format('LLLL');
      } else {
        return 'N/A';
      }
    },
    changeFormatDate(day){
      if(day) {
        return moment(day).format('MMMM Do YYYY');
      } else {
        return 'N/A';
      }
    },
    updateNote() {
      if(this.checkout_info && this.checkout_info.customer) {
        const obj = {
            phone: this.checkout_info.customer.phone,
            note: this.note,
            // page: this.currentPage,
            // "per-page": this.itemsPerPage,
            id: this.checkout_info.id
        }
        this.$store.dispatch('checkin/UPDATE_CUSTOMER_NOTE', obj).then(() => {
            this.$vs.notify({
            title:'Notification',
            text:'Update Customer Note Successful',
            color:'success',
            position:'top-right'});
            this.popupNote = false;
            this.note_view = this.note_temp;
        }).catch(() => {
            this.$vs.notify({
            title:'Notification',
            text:'Update Customer Note Fail',
            color:'danger',
            position:'top-right'});
            this.popupNote = false;
        })

      }
    }
  },
  computed:{
    checkout_info(){
      return this.$store.state.checkin.checkoutInfo;
    },
    checkoutData(){
      return this.$store.state.checkin.checkoutData;
    },
    note: {
      get() {
        return this.note_temp;
      },
      set(value) {
        this.note_temp = value;
      }
    },
    email: {
      get(){
        return this.email_temp;
      },
      set(value){
        this.email_temp = value;
      }
    }
  }
}
</script>
